import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { FC, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { WithChildren } from 'ts-types';

type Props = {
  firstTile?: string;
  secondTitle?: string;
} & WithChildren;

const SCROLLBAR_HEIGHT = '300px';

export const AccordionComponent: FC<Props> = ({ firstTile, secondTitle, children }) => {
  const [isShow, setIsShow] = useState(false);

  return (
    <div className={styles.accordionContainer}>
      <div className={styles.accordionHeader}>
        <div>
          <span className={styles.firstTile}>{firstTile}</span>
          <span className={styles.secondTitle}>{secondTitle}</span>
        </div>
        <button type="button" className={styles.actionBtn} onClick={() => setIsShow((x) => !x)}>
          {isShow ? (
            <InlineSvg path="/media/icons/custom/up-square.svg" />
          ) : (
            <InlineSvg path="/media/icons/custom/down-square.svg" />
          )}
        </button>
      </div>
      <div className={`${styles.accordionContent} ${isShow ? styles.open : ''}`}>
        <PerfectScrollbar
          style={{ maxHeight: SCROLLBAR_HEIGHT, paddingRight: '10px', marginBottom: '10px', width: '100%' }}
        >
          {children ?? <></>}
        </PerfectScrollbar>
      </div>
    </div>
  );
};
